module.exports = __webpack_public_path__ + "img/textBig.ca2a53a6.svg";